<!--
* 组件名 : 迫害升级-图片轮播器
* 开发者 : JY
*
* 参数:
*   pictures     { Object } -  轮播器数据
*   showInfo     { Boolean }   -  是否显示描述
*   className    { Boolean }   -  轮播器盒子 class
*
* 事件: null
*   
-->

<template>
  <div class="v-picture-carousel">
    <h2 class="type-title">{{ atlasTitle }}</h2>
    <div :class="['swiper-container', className]" ref="swiperCarousel">
      <div class="swiper-wrapper">
        <picture-items
          class="swiper-slide"
          :data="item"
          v-for="(item, i) in pictureData"
          :key="i"
          @update="on_update"
          :dataType="pictures.dataType"
        />
      </div>
      <v-spinner class="spinner-border" />
      <v-btn class="slick-prev" :linear="true">
        <v-icon>west</v-icon>
      </v-btn>
      <v-btn class="slick-next" :linear="true">
        <v-icon>east</v-icon>
      </v-btn>
    </div>

    <div class="picture-info-box">
      <div class="process-box">
        <p class="process-num">
          <span class="current">{{ current }}</span> /
          <span class="total">{{ total }}</span>
        </p>
        <div class="process-bar" v-if="showInfo">
          <div class="current-process" :style="{ width: processWidth }" />
        </div>
      </div>
      <div class="info-text scrollbar" v-html="infoText" v-if="showInfo" />
    </div>
  </div>
</template>

<script>
import PictureItems from "./components/picture-item/index.vue";
export default {
  name: "v-picture-carousel",
  props: {
    pictures: {
      type: Object,
      required: true,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      required: true,
    },
  },
  data() {
    this.pictureData = this.pictures.data;
    this.swiper = null;
    this.count = 0;
    return {
      current: 1,
      total: 1,
      processWidth: "0%",
      infoText: "",
      atlasTitle: "",
    };
  },

  components: {
    PictureItems,
  },
  created() {
    //  如果picture中没有传入 description,
    //  默认使用第一张图片的description
    this.atlasTitle = this.pictures.description
      ? this.pictures.description
      : this.pictureData[0].description;
  },
  mounted() {
    this.swiper_carousel();
  },

  methods: {
    init_swiper_carousel() {
      //  初始化进度条
      this.processWidth = `${(1 / this.total) * 100}%`;
      //  初始化第一张图的描述
      this.infoText = this.pictureData[0].description;
    },
    on_update() {
      this.count++;
      if (this.count === this.pictureData.length) {
        this.swiper.init();
        this.swiper.update();
        this.init_swiper_carousel();
        this.$refs.swiperCarousel.classList.add("show");
      }
      this.total = this.count;
    },
    swiper_carousel() {
      this.swiper = new Swiper(`.${this.className}`, {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        init: false,
        simulateTouch: this.$P.isIE11 ? false : true,
        navigation: {
          nextEl: ".slick-next",
          prevEl: ".slick-prev",
        },
      });

      this.swiper.on("slideChangeTransitionStart", () => {
        this.before_change();
      });
    },
    before_change() {
      //  更新计数器
      this.current = this.swiper.realIndex + 1;
      //  更新进度条
      this.processWidth = `${parseInt((this.current / this.total) * 100)}%`;
      //  更新图片描述
      this.infoText = this.pictureData[this.swiper.realIndex].description;
    },
  },
};
</script>

<style lang="scss">
.v-picture-carousel {
  padding-bottom: 150px;
  padding-top: 100px;

  .swiper-container {
    position: relative;

    &.show {
      .swiper-wrapper {
        opacity: 1;
      }

      .spinner-border {
        display: none;
      }
    }
  }

  .swiper-wrapper {
    opacity: 0;
  }

  .swiper-container {
    margin-top: 72px;
    .v-btn {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 60;
      &.slick-prev {
        left: 21%;
      }

      &.slick-next {
        right: 21%;
      }

      .borderCircle--canvasBox {
        display: none;
      }

      .borderCircle {
        border-width: 2px;
      }
    }

    .spinner-border {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 20;
      display: block;
      margin: auto;

      .path {
        stroke: #3a3a3a;
      }
    }
  }

  .picture-info-box {
    margin-top: 40px;

    .process-num {
      font-size: 18px;
      font-family: "Oxygen";
      text-align: center;
      color: rgba($color-icon, 0.67);

      .current {
        color: #95230d;
      }
    }

    .info-text {
      margin: 16px auto 32px auto;
      width: 464px;
      height: calc(4em * 1.5);
      padding-right: 8px;
      overflow-y: auto;
    }
  }

  @media (min-width: $lx-max) {
    .swiper-container {
      .v-btn.slick-prev {
        left: 24%;
      }

      .v-btn.slick-next {
        right: 24%;
      }
    }

    .picture-info-box {
      .info-text {
        width: 656px;
      }
    }
  }
}
</style>
